/* Common Imports */

import React from "react";
import loadable from "@loadable/component";

/* Component Imports */

import Layout from "../../components/layout-components/Layout";
import SectionOne from "../../components/page-sections/career/SectionOne";
const SectionTwo = loadable(() =>
  import("../../components/page-sections/career/SectionTwo")
);
const SectionThree = loadable(() =>
  import("../../components/page-sections/career/SectionThree")
);
const SectionFour = loadable(() =>
  import("../../components/page-sections/career/SectionFour")
);

const Careers = () => {
  return (
    <React.Fragment>
      <Layout>
        {/* Page Header */}
        <SectionOne />

        {/* Skill Cards */}
        <SectionTwo />

        {/* Career Tabs */}
        <SectionThree />

        {/* Our HQ */}
        <SectionFour />
      </Layout>
    </React.Fragment>
  );
};

export default Careers;
